import { render } from "./BrandFaqMainContent.vue?vue&type=template&id=0364bb68&scoped=true"
import script from "./BrandFaqMainContent.vue?vue&type=script&lang=js"
export * from "./BrandFaqMainContent.vue?vue&type=script&lang=js"

import "./BrandFaqMainContent.vue?vue&type=style&index=0&id=0364bb68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0364bb68"]])

export default __exports__